import { breakpoints, matchBreakpoint } from "../common/utils";
(() => {
  const accordionTrigger = $("[data-accordion-trigger]");
  const accordionRWDTrigger = $("[data-accordion-rwd-trigger]");
  const ACTIVE_CLASS = "active";
  const accordionInit = event => {
    const that = $(event.target);
    const className = that.attr("class").split(" ")[0];
    const thatId = that.attr("data-accordion-trigger");
    const container = $(`[data-accordion-container=${thatId}]`);

    container.toggleClass("show");
    that.toggleClass(`${className}--${ACTIVE_CLASS}`);
  };

  const initAccordionRWDTrigger = (e, self) => {
    e.preventDefault();
    const className = self.attr("class").split(" ")[0];
    const thatId = self.attr("data-accordion-rwd-trigger");
    const container = $(`[data-accordion-rwd-container=${thatId}]`);

    container.toggleClass("show");
    self.toggleClass(`${className}--${ACTIVE_CLASS}`);
  };

  accordionTrigger.on("click", accordionInit);

  accordionRWDTrigger.each(function() {
    let self = $(this);

    self.on("click", e => initAccordionRWDTrigger(e, self));
  });
})();
